import React from 'react';
import './Day.css';
import { clearSelected } from './Week.js';
import { getSelectedDate, setDayComponent } from './filter.js';
import { clearFilter } from './FilterTasks';

// function selectDate() {
//    var date = document.getElementById("circle").value;
//    document.getElementById("date").classList.add("day-selected");
// }

class Day extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         date: this.props.date,
         day: this.props.day,
         class: this.props.class
      }
      setDayComponent(this, this.state.day);
   }
   selectDate = () => {
      clearFilter();
      // clearSelected();
      // add selected class to the day on top of existing classes
      
      // check if the day is already selected
      if (this.state.class.includes("day-selected")) {
         this.setState({ class: this.state.class.replace("day-selected", "") }, () => {
            getSelectedDate(this);
         });
         // console.log("unselected");
      } 
      else if(document.getElementsByClassName("day-selected").length > 0) {
         clearSelected();
         this.setState({ class: this.state.class + "day-selected" }, () => {
            getSelectedDate(this);
         });
      }
      else {
         this.setState({ class: this.state.class + "day-selected" }, () => {
            getSelectedDate(this);
         });
      }
      // update state

      
      var state = this.state;
      // console.log(state);
   }

   render() {
      return (
         <div id="day">
            <i className="date" style={{ display: "none" }}>{this.props.fulldate}</i>
            <h1>{this.props.day}</h1>
            <div id="circle" value="00" onClick={this.selectDate} className={this.state.class +" circle"}>{this.props.date}</div>
         </div>
      );
   }
}
export default Day;